function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import GridImage from "segments/desktop/core-components/grid-image/grid-image";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { getImageSize } from "segments/desktop/grid/grid-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { gettArrayWithIncrementingNumbers } from "utils/arrays";
import DefaultProps from "./default-props";
import { StyledImagesGrid } from "./images-grid.scss";
class ImagesGrid extends PureComponent {
    renderImages() {
        const { images, isWithParagraph, imagePosition, textAlign, disableFixedWidth, titleSize, textSize, isMobileOrTabletBrowser, imageStyle, isIcon, numberOfCardsInRow, fitHeightToImgHeight, buttonTopMargin, alignButtons } = this.props;
        return images.map((image, index)=>{
            const { height, width } = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser);
            const { fullParagraph, shadow } = image, restImageProps = _object_without_properties(image, [
                "fullParagraph",
                "shadow"
            ]);
            return /*#__PURE__*/ _jsxs("div", {
                className: classnames("grid-image-container", {
                    "dynamic-width": disableFixedWidth
                }),
                style: {
                    "--grid-width": `${width}px`
                },
                children: [
                    (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ _jsx("div", {
                        className: classnames("grid-image-wrapper", shadow && "with-shadow"),
                        children: /*#__PURE__*/ _jsx(GridImage, _object_spread_props(_object_spread({
                            height: fitHeightToImgHeight || isIcon ? "auto" : height,
                            width: width,
                            imageStyle: imageStyle,
                            imagePosition: imagePosition
                        }, restImageProps), {
                            className: "image"
                        }))
                    }),
                    isWithParagraph && /*#__PURE__*/ _jsx("div", {
                        className: classnames("full-paragraph-wrapper", {
                            "buttons-alignment": alignButtons
                        }),
                        children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraph), {
                            textAlign: textAlign,
                            titleSize: titleSize,
                            textSize: textSize,
                            buttonTopMargin: buttonTopMargin
                        }))
                    })
                ]
            }, index);
        });
    }
    renderEmpty() {
        const { images, numberOfCardsInRow, isMobileOrTabletBrowser } = this.props;
        const emptyPlaces = gettArrayWithIncrementingNumbers(numberOfCardsInRow - images.length);
        const { width } = getImageSize(numberOfCardsInRow || images.length, isMobileOrTabletBrowser);
        return emptyPlaces.map((index)=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "grid-image-container",
                style: {
                    width
                }
            }, index);
        });
    }
    render() {
        const { imagesGap, disableFixedWidth } = this.props;
        return /*#__PURE__*/ _jsxs(StyledImagesGrid, {
            className: classnames("images-grid", {
                "no-wrap": disableFixedWidth
            }),
            style: {
                gap: imagesGap
            },
            children: [
                this.renderImages(),
                this.shouldAddEmptyContainer() && this.renderEmpty()
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "shouldAddEmptyContainer", ()=>{
            const { images, numberOfCardsInRow } = this.props;
            return numberOfCardsInRow && numberOfCardsInRow >= images.length;
        });
    }
}
export default withGenericConfig(ImagesGrid);
ImagesGrid.defaultProps = DefaultProps;
